import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Lightbulb, Plane, Shield, Globe2, Battery, Wallet } from 'lucide-react';

export const TravelTips = () => {
  const tips = [
    {
      icon: Shield,
      title: "Travel Insurance",
      description: "Always get travel insurance for international trips"
    },
    {
      icon: Battery,
      title: "Power Bank",
      description: "Carry a power bank for emergency charging"
    },
    {
      icon: Globe2,
      title: "Local Customs",
      description: "Research local customs and traditions"
    },
    {
      icon: Wallet,
      title: "Emergency Cash",
      description: "Keep some emergency cash in local currency"
    },
    {
      icon: Plane,
      title: "Flight Check-in",
      description: "Check-in online to save time at the airport"
    }
  ];

  return (
    <Card className="p-4 bg-gradient-to-br from-purple-50 to-purple-100">
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className="h-5 w-5 text-purple-500" />
        <h3 className="text-lg font-semibold">Travel Tips</h3>
      </div>
      <ScrollArea className="h-[200px]">
        <div className="space-y-4">
          {tips.map((tip, index) => (
            <div key={index} className="flex items-start gap-3 p-2 rounded-lg hover:bg-white/50 transition-colors">
              <tip.icon className="h-5 w-5 text-purple-500 mt-1" />
              <div>
                <h4 className="font-medium">{tip.title}</h4>
                <p className="text-sm text-muted-foreground">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>
      </ScrollArea>
    </Card>
  );
};